/**
 * PathCreator
 * Handles the look of selected tiles and also create connections between them.
 */

export default class PathCreator {

    // ==================== Construction ====================
    constructor(game, connectionsView, board) {
        this.board = board;
        this.game = game;
        this.connectionsView = connectionsView;
        this.connections = [];
    }

    // ==================== Update ====================
    updatePath(valid) {
        this.updateSelectedTilesVisual(valid);
        this.updateConnectionsVisual(valid);
    }

    hideConnections() {
        this.connectionsView.removeAll();
    }

    updateConnectionsVisual(valid) {
        var selected = this.board.boardInputController.selected;

        this.connectionsView.removeAll();
        this.connections = [];

        for (var i = 0; i < selected.length - 1; i++) {
            var connectionType = this.getConnectionTypeBetweenTiles(selected[i], selected[i + 1]);
            var connectionName = 'connection' + (valid ? 'Correct' : 'Wrong') + connectionType + '.png';
            var connection = PARAMS.makeSprite(this.game, 0, 0, 'gameElements', connectionName);
            connection.anchor.set(0.5);

            this.placeConnectionBetweenTiles(connection, selected[i], selected[i + 1]);
            this.connections.push(connection);
            this.connectionsView.add(connection);
        }
    }

    updateSelectedTilesVisual(valid) {
        var selected = this.board.boardInputController.selected;
        for (var i = 0; i < selected.length - 1; i++) {
            selected[i].updateView(valid, false)
        }

        if (selected.length > 0) {
            selected[selected.length - 1].updateView(valid, true)
        }
    }

    updateSelectedTilesForPowerup() {
        var valid = true;
        var selected = this.board.boardInputController.selected;

        for (var i = 0; i < selected.length - 1; i++) {
            selected[i].updateView(valid, false, true)
        }

        if (selected.length > 0) {
            selected[selected.length - 1].updateView(valid, true, true)
        }

        this.hideConnections()
    }

    getConnectionTypeBetweenTiles(tileFrom, tileTo) {
        var rowDiff = tileTo.row - tileFrom.row;
        var colDiff = tileTo.col - tileFrom.col;

        var row = '';
        var col = '';

        if (rowDiff === 1) row = 'S';
        else if (rowDiff === -1) row = 'N';

        if (colDiff === 1) col = 'E';
        else if (colDiff === -1) col = 'W';

        return row + col
    }

    placeConnectionBetweenTiles(connection, tileA, tileB) {
        var x = (tileA.view.x + tileB.view.x + 47 * PARAMS.scaleFactor) / 2;
        var y = (tileA.view.y + tileB.view.y + 47 * PARAMS.scaleFactor) / 2;

        connection.x = x;
        connection.y = y
    }

    // ==================== Destruction ====================
    destroy() {
        this.connectionsView.removeAll();
        this.connections.length = 0;
    }
}
